import React from 'react'

const NotFound = () => {
  return (
    <div>Page Not Found (Error 404)</div>
  )
}

export default NotFound